import React from "react";
import ReactDatePicker from "react-datepicker";
import { useTranslation } from "./TranslationProvider";
import { fi, sv, enGB, ru } from "date-fns/locale";

// Map app language codes to date-fns locales
const localeByLang = {
  fi,
  se: sv,
  sv,
  en: enGB,
  ru,
};

const DatePickerInput = ({ ...props }) => {
  const { lang } = useTranslation();
  const localeObj = localeByLang[lang] || enGB;

  return (
    <ReactDatePicker
      locale={localeObj}
      className={ "form-control"}
      {...props}
    />
  );
};

export default DatePickerInput;
